<template>
  <div class="content">
    <div class="head_box">
      <!-- <div class="head_title">一站式无车承运物流服务平台</div>
      <div class="internet">
        <div class="internet_left">互联网 + 大数据</div>
        <div class="internet_right">整车物流</div>
      </div> -->
    </div>
    <!-- 查询 -->
    <div class="query_box">
      <el-form :inline="true" class="myform">
        <el-form-item label="订单查询">
          <el-input v-model="TransportDocNO" placeholder="订单编号" style="width:720px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="query" style="width:120px">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 行程信息 -->
    <div class="trip_box">
      <div class="trip_item">
        <div>运单编号：{{detaildata.TransportDocNO}}</div>
        <div>客户单号：{{detaildata.ManualNO}}</div>
      </div>
      <div class="startend_box">
        <div class="state">运输中</div>
        <div class="bottom">
          <div>{{detaildata.StartingCity}}</div>
          <img src="../assets/img/箭头.png" alt="">
          <div>{{detaildata.DestinationCity}}</div>
        </div>
      </div>
      <div class="trip_item">
        <div>订单时间：{{detaildata.AcceptDate}}</div>
        <div>预达时间：{{detaildata.RequiredDate}}</div>
      </div>
    </div>
    <!-- 地图 -->
    <div id="map_my" :style="{width: `1000px`,height: `500px`}"></div>
    <!-- 运单信息 -->
    <div class="basicsdata">
      <el-row class="row_box">
        <el-col :span="5">
          <span>发货单位：{{detaildata.CustomerName}}</span>
        </el-col>
        <el-col :span="4">
          <span>发货人：{{detaildata.DeliveryContact}}</span>
        </el-col>
        <el-col :span="15">
          <span>发货地址：{{detaildata.DeliveryAddress}}</span>
        </el-col>
        <!-- <el-col :span="4">
          <span>车牌号：{{detaildata.TruckNO}}</span>
        </el-col> -->
      </el-row>
      <el-row class="row_box">
        <el-col :span="9">
          <span>收货单位：{{detaildata.ConsigneeName}}</span>
        </el-col>
        <el-col :span="5">
          <span>收货人：{{detaildata.ConsigneeContact}}</span>
        </el-col>
        <el-col :span="5">
          <span>收货电话：{{detaildata.ConsigneeTel}}</span>
        </el-col>
        <el-col :span="5">
          <span>收货手机：{{detaildata.ConsigneeMobile}}</span>
        </el-col>
      </el-row>
      <el-row class="row_box">
        <el-col :span="24">
          <span>收货地址：{{detaildata.ConsigneeAdress}}</span>
        </el-col>
      </el-row>
      <el-row class="row_box">
        <el-col :span="5">
          <span>回单编号：无</span>
        </el-col>
        <el-col :span="4">
          <span>交货方式：{{detaildata.DeliveryMode}}</span>
        </el-col>
        <el-col :span="15">
          <span>运单备注：{{detaildata.Remark}}</span>
        </el-col>
      </el-row>
    </div>
    <!-- 货物信息 -->
    <div class="goodsdata">
      <table cellpading="0" cellspacing="0">
        <thead>
          <td>品名</td>
          <td>货号</td>
          <td>包装方式</td>
          <td>件数</td>
          <td>箱数</td>
          <td>重量</td>
          <td>体积</td>
          <td>货物备注</td>
        </thead>
        <tr v-for="item in PartList">
          <td>{{item.PartName}}</td>
          <td>{{item.ModelNO}}</td>
          <td>{{item.Package}}</td>
          <td>{{item.EAQty}}</td>
          <td>{{item.CSQty}}</td>
          <td>{{item.GrossWeight}}</td>
          <td>{{item.Volume}}</td>
          <td>{{item.Remark}}</td>
        </tr>
      </table>
    </div>
    <!-- 时间线 -->
    <div class="timeline_box">
      <el-timeline>
        <el-timeline-item class="mytimeline" v-for="(item,index) in DocTrackingList" :key="index" :timestamp="item.CreateDate" placement="top">
          <el-card>
            <h4>到达 【{{item.EIPEvent}}】</h4>
          </el-card>
        </el-timeline-item>
        <!-- <el-timeline-item timestamp="2022-10-23 18:05" placement="top">
          <el-card>
            <h4>到达 【上海奉贤南桥业务部】</h4>
          </el-card>
        </el-timeline-item>
        <el-timeline-item timestamp="2022-10-22 18:05" placement="top">
          <el-card>
            <h4>到达 【上海浦东新区】</h4>
          </el-card>
        </el-timeline-item>
        <el-timeline-item timestamp="2022-10-21 18:05" placement="top">
          <el-card>
            <h4>到达 【上海江苏无锡市】</h4>
          </el-card>
        </el-timeline-item> -->
      </el-timeline>
    </div>
    <!-- <div class="content_marker">已签收</div> -->
  </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader';
export default {
  data() {
    return {
      Map: null,
      TransportDocNO: '',
      // TransportDocNO: 'YD221012251',
      form: '',
      detaildata: "",
      PartList: [],
      startlnglat: '',
      endlnglat: '',
      Translnglat: '',//中转点
      DocTrackingList: [],//运单跟踪信息
    }
  },
  created() { },
  mounted() {
    //接收参数
    let docno = this.$route.query.docno;
    this.TransportDocNO = docno;
    window._AMapSecurityConfig = {
      securityJsCode: '416e79abccde9518f32eab77c6898c1b',
    }
    let that = this;
    AMapLoader.load({
      "key": "8d091ded0c83645a615bd39c1e20b34f",// 申请好的Web端开发者Key，首次调用 load 时必填
      "version": "2.0",// 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
      "plugins": ['AMap.Driving', 'AMap.Geocoder'],// 需要使用的的插件列表，如比例尺'AMap.Scale'等
    }).then((AMap) => {
      that.Map = new AMap.Map('map_my', {
        // mapStyle: 'amap://styles/65d23fbb6fc619a3f04fe0a04c439cfd', //设置地图的显示样式
        features: ['bg', 'road', 'building', 'point'],// 隐藏默认楼块
        zoom: 5.5,//设置初始化级别
        // zooms: [10, 30], //设置缩放级别范围 10-15 级
        center: that.center,//中心点
      });
      // that.Load();
      if (docno) {
        this.query();
      }
    }).catch(e => {
      console.log(e);
    })
  },
  methods: {
    Load() {
    },
    async query() {
      //运单监控
      let res = await this.$api.home.TransportDocTracking({ TransportDocNO: this.TransportDocNO });
      this.detaildata = res.data[0];
      this.PartList = res.data[0].PartList;
      this.DocTrackingList = res.data[0].DocTrackingList;

      // //自定义数据
      // res.data[0].TrackList[0].DeliveryAddress = "上海市黄浦区小东门街道中山南路1356号上海纺织双龙商务楼";//发货地址
      // res.data[0].TrackList[0].ConsigneeAdress = "甘肃省兰州市七里河区西园街道南滨河中路10号广宇小区";//收货
      // res.data[0].TrackList[0].AcceptDate = "2022-10-28";//订单日期
      // res.data[0].TrackList[0].HourDays = "5";//时效天数

      console.log(res.data[0].TrackList);
      console.log('--始发地', res.data[0].TrackList[0].StartingCity, '--目的地', res.data[0].TrackList[0].DestinationCity, '发货地址', res.data[0].TrackList[0].DeliveryAddress, '中转', res.data[0].TrackList[0].TransAddress, '--收货', res.data[0].TrackList[0].ConsigneeAdress,);

      if (res.data[0].TrackList[0].DeliveryAddress == "") {
        this.$message({
          message: '发货地址为空',
          type: 'warning'
        });
        return
      }
      if (res.data[0].TrackList[0].ConsigneeAdress == "") {
        this.$message({
          message: '收货地址为空',
          type: 'warning'
        });
        return
      }
      if (res.data[0].TrackList[0].HourDays == "") {
        this.$message({
          message: '时效天数为空',
          type: 'warning'
        });
        return
      }
      this.jisuan(res.data[0].TrackList[0].DeliveryAddress, res.data[0].TrackList[0].ConsigneeAdress, res.data[0].TrackList[0].TransAddress);
    },
    jisuan(start, end, Trans) {
      var marker = new AMap.Marker();
      var geocoder = new AMap.Geocoder({
      });
      let that_ = this;
      // console.log(1);
      //地址转经纬度
      geocoder.getLocation(start, function (status, result) {
        console.log(1);
        if (status === 'complete' && result.geocodes.length) {
          that_.startlnglat = result.geocodes[0].location;
          geocoder.getLocation(end, function (status, result) {
            if (status === 'complete' && result.geocodes.length) {
              that_.endlnglat = result.geocodes[0].location;
              //有中转点
              if (Trans != "") {
                geocoder.getLocation(Trans, function (status, result) {
                  if (status === 'complete' && result.geocodes.length) {
                    that_.Translnglat = result.geocodes[0].location;
                    //导航
                    that_.driving_Trans();
                  } else {
                    log.error('根据地址查询位置失败');
                  }
                });
              }
              else {//无中转
                //导航
                that_.driving();
              }
            } else {
              log.error('根据地址查询位置失败');
            }
          });
        } else {
          log.error('根据地址查询位置失败');
        }
      });
    },
    //无中转
    driving() {
      var drivingOption = {
        policy: AMap.DrivingPolicy.LEAST_TIME, // 其它policy参数请参考 https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingPolicy
        // ferry: 1, // 是否可以使用轮渡
        province: '京', // 车牌省份的汉字缩写  
      }
      // 构造路线导航类
      var driving = new AMap.Driving(drivingOption)
      let that = this;
      // 根据起终点经纬度规划驾车导航路线
      driving.search(this.startlnglat, this.endlnglat, function (status, result) {
        // result即是对应的驾车导航信息，相关数据结构文档请参考 https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
        if (status === 'complete') {
          if (result.routes && result.routes.length) {
            // 绘制第一条路线，也可以按需求绘制其它几条路线
            that.drawRoute(result.routes[0])
            // log.success('绘制驾车路线完成')
          }
        } else {
          //   log.error('获取驾车数据失败：' + result)
        }
      });
    },
    //有中转
    driving_Trans() {
      var drivingOption = {
        policy: AMap.DrivingPolicy.LEAST_TIME, // 其它policy参数请参考 https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingPolicy
        // ferry: 1, // 是否可以使用轮渡
        province: '京', // 车牌省份的汉字缩写  
      }
      // 构造路线导航类
      var driving = new AMap.Driving(drivingOption)
      let that = this;
      // 根据起终点经纬度规划驾车导航路线
      driving.search(this.startlnglat, this.endlnglat, {
        waypoints: [this.Translnglat]
      }, function (status, result) {
        // result即是对应的驾车导航信息，相关数据结构文档请参考 https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
        if (status === 'complete') {
          if (result.routes && result.routes.length) {
            // 绘制第一条路线，也可以按需求绘制其它几条路线
            that.drawRoute(result.routes[0])
            // log.success('绘制驾车路线完成')
          }
        } else {
          //   log.error('获取驾车数据失败：' + result)
        }
      });
    },

    drawRoute(route) {
      var path = this.parseRouteToPath(route)
      console.log('路线所有经纬度', path);
      this.Map.clearMap();// 清除地图上所有添加的覆盖物
      //总段数
      let len = this.detaildata.TrackList[0].HourDays * 24;
      //现在和订单日期相差几段
      let now = this.$moment();
      let nowlen = now.diff(this.detaildata.TrackList[0].AcceptDate, 'hours');
      //现在在结束段数内
      if (nowlen < len) {
        //走了多少
        let RATIO = nowlen / len;
        let mowpathlen = parseInt(path.length * RATIO);
        // debugger
        var startMarker = new AMap.Marker({
          position: path[0],
          icon: 'https://webapi.amap.com/theme/v1.3/markers/n/start.png',
          map: this.Map
        })
        var endMarker = new AMap.Marker({
          position: path[path.length - 1],
          icon: 'https://webapi.amap.com/theme/v1.3/markers/n/end.png',
          map: this.Map,
          offset: new AMap.Pixel(-19, -19),//偏移量
        })
        //现在的位置
        var nowMarker = new AMap.Marker({
          position: path[mowpathlen],
          map: this.Map,
          icon: new AMap.Icon({
            // 图标尺寸
            size: new AMap.Size(38, 38),
            // 图标的取图地址
            image: 'http://www.haiturn.com/df_web/img/car.png',
            // 图标所用图片大小
            imageSize: new AMap.Size(38, 20),
          }),
          offset: new AMap.Pixel(-19, -5),//偏移量
        })
        //已走的路径
        let already = path.slice(0, mowpathlen);
        //未走的路径
        let nopath = path.slice(-(path.length - mowpathlen));
        //已走的
        var routeLine = new AMap.Polyline({
          path: already,
          isOutline: true,
          outlineColor: '#ffeeee',
          borderWeight: 2,
          strokeWeight: 5,
          strokeOpacity: 0.9,
          strokeColor: '#9B9B9B',
          lineJoin: 'round'
        })
        this.Map.add(routeLine);
        //未走的
        var norouteLine = new AMap.Polyline({
          path: nopath,
          isOutline: true,
          outlineColor: '#ffeeee',
          borderWeight: 1,
          strokeWeight: 5,
          strokeOpacity: 0.9,
          strokeColor: '#0091ff',
          lineJoin: 'round'
        })
        this.Map.add(norouteLine);

        // 调整视野达到最佳显示区域
        // this.Map.setFitView([startMarker, endMarker, nowMarker, routeLine,])
        this.Map.setFitView([startMarker, endMarker, nowMarker, routeLine, norouteLine])


      }
      else {//已完成，显示全部线路
        var startMarker = new AMap.Marker({
          position: path[0],
          icon: 'https://webapi.amap.com/theme/v1.3/markers/n/start.png',
          map: this.Map
        })

        //已签收
        // 点标记显示内容，HTML要素字符串
        var markerContent = '<div class="content_marker">已签收</div>';
        var endMarker = new AMap.Marker({
          position: path[path.length - 1],
          // 将 html 传给 content
          content: markerContent,
          // 以 icon 的 [center bottom] 为原点
          map: this.Map,
          offset: new AMap.Pixel(-38, 0)
        });
        // var endMarker = new AMap.Marker({
        //   position: path[path.length - 1],
        //   icon: 'https://webapi.amap.com/theme/v1.3/markers/n/end.png',
        //   map: this.Map
        // })

        var routeLine = new AMap.Polyline({
          path: path,
          isOutline: true,
          outlineColor: '#ffeeee',
          borderWeight: 2,
          strokeWeight: 5,
          strokeOpacity: 0.9,
          strokeColor: '#828282',
          lineJoin: 'round'
        })

        this.Map.add(routeLine);

        // 调整视野达到最佳显示区域
        this.Map.setFitView([startMarker, endMarker, routeLine])
      }
    },
    // 解析DrivingRoute对象，构造成AMap.Polyline的path参数需要的格式
    // DrivingResult对象结构参考文档 https://lbs.amap.com/api/javascript-api/reference/route-search#m_DriveRoute
    parseRouteToPath(route) {
      var path = []

      for (var i = 0, l = route.steps.length; i < l; i++) {
        var step = route.steps[i]

        for (var j = 0, n = step.path.length; j < n; j++) {
          path.push(step.path[j])
        }
      }

      return path
    },
    onSubmit() {

    },
  }
}
</script>

<style lang="scss">
/* 去掉地图的logo */
.amap-logo {
  display: none !important;
}
.amap-copyright {
  opacity: 0;
}
.myform .el-form-item {
  margin-bottom: 0;
}

.content_marker {
  // position: absolute;
  // top: 0px;
  padding: 5px 0;
  text-align: center;
  background: #b92730;
  color: #fff;
  border-radius: 15px;
  font-size: 14px;
  width: 80px;
}

.mytimeline {
  padding-bottom: 10px;
}
.mytimeline .el-card__body {
  padding: 10px;
}
</style>

<style lang="scss" scoped>
.content {
  width: 1000px;
  margin: 0 auto;
  // border: 1px solid rgb(235, 193, 193);
  background: #fff;
  .head_box {
    height: 290px;
    // background: #8997d5;
    background: url(../assets/img/head.jpg);
    background-size: 100% 100%;
    opacity: 0.5;
    .head_title {
      font-size: 28px;
      font-weight: bold;
      text-align: center;
      color: #fff;
      padding-top: 5px;
    }
    .internet {
      width: 270px;
      height: 30px;
      line-height: 28px;
      display: flex;
      justify-content: space-between;
      margin: 0 auto;
      margin-top: 50px;
      color: #fff;
      .internet_left {
        border: 1px solid #fff;
        flex: 1;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        text-align: center;
      }
      .internet_right {
        background: #fff;
        color: #8997d5;
        height: 100%;
        width: 112px;
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
        text-align: center;
      }
    }
  }
  //查询
  .query_box {
    padding: 5px 20px;
  }
  //行程信息
  .trip_box {
    background: #ff8d1a;
    color: #fff;
    display: flex;
    justify-content: space-between;
    padding: 10px 15px;
    font-size: 14px;
    .trip_item {
      line-height: 28px;
    }
    .startend_box {
      text-align: center;
      .state {
        font-size: 18px;
      }
      .bottom {
        display: flex;
        font-size: 28px;
        align-items: center;
        img {
          width: 40px;
          height: 20px;
          margin: 0 20px;
        }
      }
    }
  }
  //运单信息
  .basicsdata {
    margin: 6px 0;
    background: #cee3f6;
    padding: 10px;
    .row_box {
      line-height: 28px;
      font-size: 14px;
    }
  }
  //货物信息
  .goodsdata {
    table {
      width: 100%;
      font-size: 14px;
      thead {
        background: #086a87;
        height: 45px;
        // line-height: 30px;
        color: #fff;
        :first-child {
          padding-left: 8px;
        }
      }
      tr {
        height: 40px;
        // line-height: 30px;
        :first-child {
          padding-left: 8px;
        }
      }
    }
  }
  //时间线
  .timeline_box {
    margin-top: 20px;
    padding: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/home.vue